module.exports = __webpack_public_path__ + "static/media/3.a4a8a0c8.jpg";